import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CarePlanFormComponent } from '../admission/care-plan-form/care-plan-form.component';

@Injectable({
    providedIn: 'root'
})
export class CarePlanDialogService {
    private dialog = inject(MatDialog);

    /**
     * Open care plan dialog
     * @param carePlanId - Optional existing care plan ID for editing
     * @param admissionSubmitted - Whether admission is already submitted (enables tasks)
     */
    openCarePlanDialog(carePlanId?: string, admissionSubmitted: boolean = true): MatDialogRef<CarePlanFormComponent> {
        const dialogRef = this.dialog.open(CarePlanFormComponent, {
            // width: '95vw',
            maxWidth: '680px',
            maxHeight: '90vh',
            disableClose: true,
            data: {
                carePlanId: carePlanId || null,
                admissionSubmitted: admissionSubmitted
            }
        });

        return dialogRef;
    }
}
